import React, {PropTypes} from 'react';
import Modal from '../../../Modal';
import Form, {FormBody, FormActions, TextInput, SelectInput, DateInput, ColorInput} from '../../../Form';
import {inject, observer} from 'mobx-react';
import {observable, action, toJS} from 'mobx';

@inject('workOrderStore', 'userStore', 'inventoryItemStore')
@observer
class WorkOrderTaskAdd extends React.Component {

  static propTypes = {
    route: PropTypes.shape().isRequired,
  };

  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  slug = this.props.params.work_order_id ? `/station/${this.props.params.id}/maintenance/work_order/${this.props.params.work_order_id}/view/tasks` : `/monitoring/work_order/tabular/${this.props.params.id}/view/tasks`;
  title = 'Add Work Order Task';
  @observable item = {
    description: '',
    item_id: null,
    assigned_to: null,
    estimated_man_hours: null,
    hours_spent: null,
    task_result: '',
    task_status: ''
  };

  @action onChangeItem = e => this.item.item_id = +e.target.value;
  @action onChangeDescription = e => this.item.description = e.target.value;
  @action onChangeAssignedTo = e => this.item.assigned_to = +e.target.value;
  @action onChangeEstimatedManHours = e => this.item.estimated_man_hours = +e.target.value;
  @action onChangeHoursSpent = e => this.item.hours_spent = +e.target.value;
  @action onChangeTaskResult = e => this.item.task_result = e.target.value;
  @action onChangeTaskStatus = e => this.item.task_status = e.target.value;

  handleSave = e => {
    e.preventDefault();

    const {workOrderStore} = this.props;
    const {notify} = this.context;

    if(!!+this.props.workOrder_id){
      workOrderStore.createTaskItem(this.props.workOrder_id, this.item)
        .then(() => {
          notify.success({message: 'Success'});
          this.context.router.push(this.slug);
        })
        .catch(err => {
          notify.error(err);
        });
    }
  };

  render() {
    const {inventoryItemStore, userStore} = this.props;
    return (
      <Modal slug={this.slug} title={this.title}>
        <Form>
          <FormBody>
            <TextInput label='Description' value={this.item.description} onChange={this.onChangeDescription}/>
            <SelectInput label='Item' value={this.item.item_id} options={inventoryItemStore.items} fields={{value: 'id', label: 'serial_no'}} onChange={this.onChangeItem}/>
            <SelectInput label='Assigned To' value={this.item.assigned_to} options={userStore.items} fields={{value: 'id', label: 'name'}} onChange={this.onChangeAssignedTo}/>
            <TextInput label='Estimated Man Hours' value={this.item.estimated_man_hours} onChange={this.onChangeEstimatedManHours}/>
            <TextInput label='Hours Spent' value={this.item.hours_spent} onChange={this.onChangeHoursSpent}/>
            <TextInput label='Task Result' value={this.item.task_result} onChange={this.onChangeTaskResult}/>
            <TextInput label='Task Status' value={this.item.task_status} onChange={this.onChangeTaskStatus}/>
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default WorkOrderTaskAdd;


// WEBPACK FOOTER //
// ./src/components/Maintenance/WorkOrder/Task/WorkOrderTaskAdd.js